import { ACHProcessorBoardingFields } from "globalConstants";
import {
	AchBoardingStatusTypes,
	HowDoYouReceivePaymentAuthTypes,
	StraddleAccountStatusTypes,
	WhoAreYourCustomersTypes,
} from "types";
import { floatWithComma2Normalizer } from "validators";

export const mapBoardingAchProcessorData = (data: { [key: string]: any }) => {
	const {
		ACHLabel,
		ACHPayoutsLabel,
		AchBoardingStatus,
		BillingAccount,
		BillingAccountName,
		BillingBank,
		BillingRouting,
		CustomerType,
		HighTicketAch,
		HighTicketAchPayouts,
		MonthlyVolumeAch,
		MonthlyVolumeAchPayouts,
		PaymentAuthorizationType,
		StatementDescriptor,
		StraddleGateId,
		StraddleGateKeyId,
		StraddleIdentifier,
		StraddleAccountStatus,
		TicketCountAch,
		TicketCountAchPayouts,
		UseOfPaymentServiceDescription,
	} = ACHProcessorBoardingFields;

	return {
		[AchBoardingStatus.name]: AchBoardingStatusTypes.getByValue(
			data[AchBoardingStatus.beName],
		),
		[StraddleIdentifier.name]: data[StraddleIdentifier.beName],
		[StraddleGateId.name]: data[StraddleGateId.beName],
		[StraddleGateKeyId.name]: data[StraddleGateKeyId.beName],
		[StraddleAccountStatus.name]: StraddleAccountStatusTypes.getByName(
			data[StraddleAccountStatus.beName],
		)?.displayName,
		[CustomerType.name]: WhoAreYourCustomersTypes.getByName(
			data[CustomerType.beName],
		)?.displayName,
		[PaymentAuthorizationType.name]:
			HowDoYouReceivePaymentAuthTypes.getByName(
				data[PaymentAuthorizationType.beName],
			)?.displayName,
		[StatementDescriptor.name]: data[StatementDescriptor.beName],
		[UseOfPaymentServiceDescription.name]:
			data[UseOfPaymentServiceDescription.beName],
		[BillingRouting.name]: data[BillingRouting.beName],
		[BillingAccount.name]: data[BillingAccount.beName],
		[BillingBank.name]: data[BillingBank.beName],
		[BillingAccountName.name]: data[BillingAccountName.beName],
		[MonthlyVolumeAch.name]: `$${floatWithComma2Normalizer(
			data[MonthlyVolumeAch.beName],
		)}`,
		[TicketCountAch.name]: data[TicketCountAch.beName],
		[HighTicketAch.name]: `$${floatWithComma2Normalizer(
			data[HighTicketAch.beName],
		)}`,
		[MonthlyVolumeAchPayouts.name]: `$${floatWithComma2Normalizer(
			data[MonthlyVolumeAchPayouts.beName],
		)}`,
		[TicketCountAchPayouts.name]: data[TicketCountAchPayouts.beName],
		[HighTicketAchPayouts.name]: `$${floatWithComma2Normalizer(
			data[HighTicketAchPayouts.beName],
		)}`,
		[ACHLabel.name]: data[ACHLabel.beName],
		[ACHPayoutsLabel.name]: data[ACHPayoutsLabel.beName],
	};
};
